import React, { createContext, useContext } from 'react'

export const StatusCodeContext = createContext(null)

export const useStatusCode = () => {
    const context = useContext(StatusCodeContext)
    return context
};

export const StatusCodeProvider = ({ children, context: serverContext }) => {
    const value = serverContext || {}

    return (
        <StatusCodeContext.Provider value={value}>
            {children}
        </StatusCodeContext.Provider>
    )
}